export default {"src":"/_next/static/media/cart.f97b5c96.svg","height":21,"width":23};